import React, { Component } from 'react';

import {
  Route,
  Redirect,
} from 'react-router-dom';

// pages
import TopNav from '../../pages/Nav/TopNav';
// import LeftNav from '../../pages/Nav/LeftNav';
import Logs from '../../pages/Logs/Logs';
import Properties from '../../pages/Properties/Properties';
import Settings from '../../pages/Settings/Settings';
import VerifyEmail from '../../pages/VerifyEmail/VerifyEmail';
// stores
import UserStore from '../../stores/UserStore';

import './App.css';

class App extends Component {
  render() {
    let {
      ...props
    } = this.props;

    return (
      <Route {...props} render={
        (props) => {
          if (UserStore.isEmailVerified()) {
            return this.renderApp();
          } else {
            return <VerifyEmail />
          }
        }} />
    );
  }

  renderApp() {
    const match = this.props.match || { url: "" };

    return (
      <div className="App">
        <div className="App-header">
          <TopNav />
        </div>
        <div className="App-body">
          {/* <LeftNav match={match} /> */}
          <Route exact path={`${match.url}/`} component={() => <Redirect to={`${match.url}/properties`} />} />
          <Route path={`${match.url}/logs`} component={Logs} />
          <Route path={`${match.url}/properties`} component={Properties} />
          <Route path={`${match.url}/settings`} component={Settings} />
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/entries/App/App.js